import React from 'react'
import { Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import Logo1 from "../assets/images/logo-footer.svg";
import Logo from "../assets/images/logo.png";

import Facebook from '../assets/images/facebook.svg'
import X from '../assets/images/x.svg'
import Linkedin from '../assets/images/linkedin.svg'
import Instagram from '../assets/images/instagram.svg'
import Youtube from '../assets/images/youtube.svg'
function Footer() {
  return (
    <>
     <footer className="common-padding">
      <Container>
        <div className='footer-top'>
          <Link to={"/"}>
             <img width={160}  className='footer-logo' src={Logo} alt="" />
          </Link>
          <ul>
            <li>
              <Link  to={"/"} title='Facebook'>
                <img src={Facebook} alt="" />
              </Link>
            </li>
            <li> 
              <Link  to={"/"} title='Twiter'>
                <img src={X} alt="" />
              </Link>
            </li>
            <li>
              <Link  to={"/"} title='Instagram'>
                <img src={Instagram} alt="" />
              </Link>
            </li>
            <li>
              <Link  to={"/"} title='Youtube'>
                <img src={Youtube} alt="" />
              </Link>
            </li>
            <li>
              <Link  to={"/"} title='Linkedin'>
                <img src={Linkedin} alt="" />
              </Link>
            </li>
          </ul>
        </div>
        <div className='footer-mid'>
          <ul>
            <li>
              <Link to={"/about-us"}>About Us</Link> 
            </li>
            <li>
              <Link to={"/blogs"}>Blogs</Link>
            </li>
            <li>
              <Link to={"/news-events"}>News & Events</Link>
            </li>
            <li>
              <Link to={"/career"}>Careers</Link>
            </li>
            <li>
              <Link to={"/contact-us"}>Contact Us</Link>
            </li>
            {/* <li>
              <Link to={"/help"}>Help</Link>
            </li> */}
            <li>
              <Link to={"/become-an-agent"}>Become an Agent</Link>
            </li>
             <li>
              <Link to={"/get-pre‑qualified"}>Get Prequalified</Link>
            </li>
          </ul>
          <ul>
            <li>
              <Link to={"/terms-of-use"}>Terms of Use</Link>
            </li>
            <li>
              <Link to={"/privacy-policy"}>Privacy Policy</Link>
            </li>
            <li>
              <Link to={"/cookie-policy"}>Cookie Policy</Link>
            </li>
          </ul>
        </div>
        <div className='footer-bottom'>
          <p>Any mortgage lead generation activity in The Republic of Kenya is performed by Jambobay, LLC.</p>
          <p>*Based on average new for sale and rental listings Feb 2024 - Jan 2025.</p>
          <p>TREC: <Link to={"https://estateagentsboard.or.ke/"}>Estate Agents Registration Board</Link>, <Link to={"https://www.cak.go.ke/consumer-protection"}>Consumer Protection</Link></p>
          <p>© 2026  All rights reserved <Link to={"/"}>Jambobay</Link></p>
        </div>
      </Container>
     </footer>
    </>
  )
}
export default Footer